import { render, staticRenderFns } from "./GatForm.vue?vue&type=template&id=cdeac1ae&scoped=true&"
import script from "./GatForm.vue?vue&type=script&lang=js&"
export * from "./GatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeac1ae",
  null
  
)

export default component.exports